import e from"styled-components";import{theme as i}from"../../../theme.js";const n=e.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  padding: 0 ${i.spacing*4}px;
  height: fit-content;
  box-sizing: border-box;
  @media screen and (max-width: ${i.breakpoints.md}) {
    padding: ${i.spacing*4}px;
  }
`,t=e.h1`
  font-size: 24px;
  font-weight: 700;
  line-height: 48px;
  color: ${i.colors.gray[700]};
  margin: 0;
  @media screen and (max-width: ${i.breakpoints.md}) {
    text-align: center;
  }
  `,a=e.p`
  line-height: 24px;
  color: ${i.colors.gray[500]};
  margin: 0;
  max-width: 480px;
  @media screen and (max-width: ${i.breakpoints.md}) {
    text-align: center;
  }
`,p=e.div`
  display: flex;
  gap: ${i.spacing*4}px;
  .status-icon-container {
    min-width: 90px;
    height: 90px;
    > svg {
      width: 60px;
      height: 60px;
    }
  }
  @media screen and (max-width: ${i.breakpoints.md}) {
    flex-direction: column;
    align-items: center;
  }
`;export{n as Container,a as Message,t as Title,p as Wrapper};
